export const STORE_PROJECT_ML_MODELS = 'projectMLModelsUI';
export type STORE_PROJECT_ML_MODELS = typeof STORE_PROJECT_ML_MODELS;
